import { render, staticRenderFns } from "./inscription-list-toolbar.vue?vue&type=template&id=dd3cedf6&"
import script from "./inscription-list-toolbar.vue?vue&type=script&lang=js&"
export * from "./inscription-list-toolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports